import { WalletIcon } from '@heroicons/react/24/outline'

export default function CareerBadge() {
  return (
    <div className='flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[10px] bg-paleBlue'>
      <WalletIcon className='size-6 text-darkBlue' />
    </div>
  )
}
